import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow1Up = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.844 13.81'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.835,13.799 C22.566,13.799 22.299,13.692 22.103,13.479 L11.927,2.421 L1.751,13.479 C1.381,13.881 0.754,13.909 0.350,13.539 C-0.054,13.171 -0.081,12.546 0.289,12.144 L11.196,0.292 C11.572,-0.116 12.283,-0.116 12.658,0.292 L23.566,12.144 C23.936,12.546 23.908,13.171 23.505,13.539 C23.314,13.714 23.074,13.799 22.835,13.799 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow1Up.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
